import { TextProps } from '@betty/moonlight';
import { RadioOption } from '@betty/moonlight/lib/common/Radio/Radio.types';

export type ShopLocKeyType = keyof RegisteredLocales['shop'];
export type CommonLocKeyType = keyof RegisteredLocales['common'];

export type ShopErrorContent = {
  locNS: TextProps['locNS'];
  locKey: ShopLocKeyType | CommonLocKeyType;
};

export type ShopFilterType =
  | 'FreeSpins'
  | 'CashReward'
  | 'Purchased'
  | 'BestValue'
  | number;

export type ShopSortType = 'LowToHigh' | 'HighToLow' | 'Relevance';

export type ShopRouteParamsType = {
  sort: ShopSortType;
  type?: ShopFilterType;
};

export type SetShopFilterParamType = (
  filter: ShopFilterType | undefined,
) => void;
export type SetShopSortParamType = (sort: ShopSortType) => void;

export interface ShopSortOption extends RadioOption {
  value: ShopSortType;
}

export enum ShopErrorCode {
  InsufficientBalance = 'insufficient-balance',
  ItemNotFound = 'item-not-found',
  ItemUnderMaintenance = 'item-is-under-maintenance',
}
